class SearchController {
  constructor() {
    this.filter = true;
    this.ignoredParams = ['action', 'language'];

    this.init();
    this.initSelect2();
  }

  init() {
    const _this = this;

    return new Promise((resolve) => {
      this.bindListeners();
      this.toggleResetButton();

      resolve();
    });
  }

  initSelect2() {
    $('.filter__select--multiple').select2({
      width: '100%',
      minimumResultsForSearch: Infinity,
      dropdownParent: $('.filters'),
      placeholder: $(this).data('placeholder'),
    });

    setTimeout(() => {
      $('.select2-search__field').attr('disabled', 'disabled');
    }, 150);
  }

  bindListeners() {
    const _this = this;

    document
      .querySelector('body')
      ._addCustomEventListener('change', '.search-grid__select', _this.selectGrid.bind(_this));

    document
      .querySelector('body')
      ._addCustomEventListener('change', '.filter__select--force', _this.selectFilter.bind(_this));

    $('body').on(
      'select2:select select2:unselect',
      '.filter__select--multiple.filter__select--force',
      _this.selectFilter.bind(_this)
    );

    document
      .querySelector('body')
      ._addCustomEventListener('change', '.filter__checkbox--force', _this.checkboxFilter.bind(_this));

    document.querySelector('body')._addCustomEventListener('submit', '.search-box__form', _this.submitForm.bind(_this));

    document.querySelector('body')._addCustomEventListener('click', '.filter__reset', _this.resetFilters.bind(_this));

    document.querySelector('body')._addCustomEventListener('click', '.load-more', _this.loadMoreResults.bind(_this));
  }

  loadMoreResults(e) {
    e.preventDefault();

    const form = document.querySelector('.search-box__form');
    const el = e.targetElement;
    const page = el.getAttribute('data-pg');

    this.page = parseInt(page);
    this.setUrlParam('pg', this.page);
    this.setUrlParams(form);
    this.prepareAjax(form, true);
    this.doAjax();
  }

  selectFilter(e) {
    this.submitForm(e);
  }

  checkboxFilter(e) {
    this.submitForm(e);
  }

  selectGrid(e) {
    const el = e.targetElement;
    const form = document.querySelector('.search-box__form');

    this.grid = parseInt(el.value);
    this.page = 1;
    this.setUrlParam('grid', this.grid);
    this.setUrlParam('pg', this.page);
    this.setUrlParams(form);
    this.prepareAjax(form, true);
    this.doAjax();
  }

  submitForm(e) {
    e.preventDefault();

    const form = e.target.closest('.search-box__form');

    this.setUrlParams(form);
    this.setGridView();
    this.prepareAjax(form);
    this.doAjax();
    this.toggleResetButton();
  }

  setUrlParam(name, val) {
    const url = new URL(window.location.href);
    const params = url.searchParams;

    params.set(name, val);
    this.setHistoryState(url);
  }

  delUrlParam(name) {
    const url = new URL(window.location.href);
    const params = url.searchParams;

    params.delete(name);
    this.setHistoryState(url);
  }

  setUrlParams(form) {
    const url = new URL(window.location.href);
    const params = url.searchParams;
    const formData = new FormData(form);
    const paramsRef = Array.from(params.entries());

    for (const d of paramsRef) {
      if (d[0] == 'pg' && d[1] !== '1') continue;
      if (d[0] == 'grid' && d[1] !== '12') continue;
      params.delete(d[0]);
    }

    for (const d of formData.entries()) {
      if (this.ignoredParams.includes(d[0])) continue;
      params.append(d[0], d[1]);
    }

    this.setHistoryState(url);
  }

  getUrlParams(form) {
    let data = '';
    const formData = new FormData(form);

    data += '&' + new URLSearchParams(formData);

    if (this.page) data += '&pg=' + this.page;
    if (this.grid) data += '&grid=' + this.grid;

    return data;
  }

  setGridView() {
    const grid = document.querySelector('.search-grid__select');
    this.grid = grid.value;
  }

  setHistoryState(url) {
    history.replaceState(null, '', url.href);
  }

  prepareAjax(form, paginate = false) {
    this.container = document.querySelector('.filters__section');

    if (!paginate) {
      this.resetPagination();
    }

    this.data = this.getUrlParams(form);
  }

  toggleResetButton() {
    let form = document.querySelector('.search-box__additionnal-setting');

    if (form) {
      form = form.closest('.search-box__form');
      const formData = new FormData(form);
      let isEmptyForm = true;

      for (const data of formData.entries()) {
        if (this.ignoredParams.includes(data[0])) continue;
        if (data[1]) {
          isEmptyForm = false;
          break;
        }
      }

      if (isEmptyForm) form.classList.add('is-empty');
      else form.classList.remove('is-empty');
    }
  }

  toggleAjaxOverlay() {
    const overlayIsActive = document.querySelector('#page').classList.contains('load-overlay');

    if (!overlayIsActive) {
      11;
      const icon = document.createElement('div');
      icon.classList.add('load-overlay__icon');

      document.querySelector('#page').classList.add('load-overlay');
      document.querySelector('body').appendChild(icon);
    } else {
      document.querySelector('.load-overlay').classList.remove('load-overlay');
      document.querySelector('.load-overlay__icon').remove();
    }
  }

  doAjax() {
    const _this = this;

    this.toggleAjaxOverlay();

    fetch(ajaxurl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Cache-Control': 'no-cache',
      },
      body: _this.data,
    })
      .then((response) => {
        if (!response.ok) {
          this.toggleAjaxOverlay();
          throw Error(response.statusText);
        }
        return response;
      })
      .then((response) => response.text())
      .then((data) => {
        const PARSER = new DOMParser();
        const DOC = PARSER.parseFromString(data, 'text/html');

        const blocks = DOC.querySelectorAll('.filters__block');
        const count = DOC.querySelector('.search-count');
        const pagination = DOC.querySelector('.em-pagination');

        // Blocks
        if (_this.filter) _this.container.querySelectorAll('.filters__block')._remove();
        if (blocks.length) _this.container.querySelector('.filters__section__results')._appendAll(blocks);

        // Count
        const currentCount = _this.container.querySelector('.search-count');
        if (currentCount) currentCount.replaceWith(count);

        // Pagination
        const currentPagination = _this.container.querySelector('.em-pagination');
        if (currentPagination) currentPagination.replaceWith(pagination);

        document.querySelectorAll('.remove-on-search')._remove();

        document.dispatchEvent(new Event('_page_loaded'));

        WebitScrollTo.scrollTo({ element: 'body' });
        _this.resetProps();
        _this.toggleAjaxOverlay();
      })
      .catch((error) => console.error(error));
  }

  resetFilters(e) {
    const form = document.querySelector('.search-box__form');

    if (form) {
      form.reset();
      document.querySelectorAll('.filter__select--multiple').forEach((e) => $(e).val(null).trigger('change'));
      this.submitForm(e);
    }
  }

  resetProps() {
    this.container = false;
  }

  resetPagination() {
    this.page = false;
    this.delUrlParam('pg');
  }
}

document.addEventListener('readystatechange', (event) => {
  if (document.readyState == 'complete') {
    window.SearchController = new SearchController();
  }
});
